import { memo, useState, useCallback } from 'react';
import { cn, Gallery } from '@divlab/divanui';

import useMedias from '@Hooks/useMedias';
import Img from '@UI/Img';
import NavSideArrows from '@Components/NavSideArrows';
import styles from './FullscreenSlider.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { SwiperClass } from '@divlab/divanui';

export interface MaediaData {
  img: string;
  sign: string;
}

interface FullscreenSliderProps extends HTMLAttributes<HTMLDivElement> {
  medias: MaediaData[];
}

const FullscreenSlider: FC<FullscreenSliderProps> = (props) => {
  const { medias, className, ...restProps } = props;
  const { isMobileM } = useMedias();
  const [slideIndex, setSlideIndex] = useState(0);

  const handleSlideChange = (swiper: SwiperClass) => setSlideIndex(swiper.realIndex);

  const renderButtons = useCallback(
    ({ onPrev, onNext }) => {
      if (medias.length < 2 || isMobileM) return null;

      return <NavSideArrows className={styles.arrows} onPrev={onPrev} onNext={onNext} />;
    },
    [isMobileM, medias.length],
  );

  if (!medias.length) return null;

  return (
    <Gallery
      className={cn(styles.wrapper, className)}
      cnGallery={styles.gallery}
      cnSlide={styles.slide}
      slidesPerView={1}
      initialSlideIndex={slideIndex}
      onSlideChange={handleSlideChange}
      renderButtons={renderButtons}
      loop
      pagination
      {...restProps}
    >
      {medias.map((media) => (
        <Img key={media.img} src={media.img} />
      ))}
    </Gallery>
  );
};

export default memo(FullscreenSlider);
